import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loaded: false,
  loading: false,
  error: null,
  hospitalId: null,
  name: null,
  modules: { lis: false, ris: false, emr: false },
  features: {},
  workflows: {},
  branding: {},
  localization: {},
}

const slice = createSlice({
  name: 'hospitalConfig',
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true
      state.error = null
    },
    fetchSuccess: (state, action) => {
      state.loading = false
      state.loaded = true
      state.hospitalId = action.payload.hospitalId
      state.name = action.payload.name
      state.modules = action.payload.modules ?? state.modules
      state.features = action.payload.features ?? {}
      state.workflows = action.payload.workflows ?? {}
      state.branding = action.payload.branding ?? {}
      state.localization = action.payload.localization ?? {}
    },
    fetchFailure: (state, action) => {
      state.loading = false
      state.error = action.payload
    },
  },
})

export const { fetchRequest, fetchSuccess, fetchFailure } = slice.actions
export default slice.reducer

export const selectHospitalConfig = (state) => state.hospitalConfig

export const isModuleEnabled = (state, id) => {
  const m = state.hospitalConfig?.modules?.[id]
  if (typeof m === 'boolean') return m
  return !!m?.enabled
}
